import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CurrentPlanCard = ({ currentPlan, onUpgrade, onManageBilling }) => {
  const getPlanIcon = (planType) => {
    switch (planType) {
      case 'basic': return 'Zap';
      case 'premium': return 'Star';
      case 'professional': return 'Crown';
      default: return 'Package';
    }
  };

  const getPlanColor = (planType) => {
    switch (planType) {
      case 'basic': return 'text-accent';
      case 'premium': return 'text-secondary';
      case 'professional': return 'text-success';
      default: return 'text-muted-foreground';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-start justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className={`w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center`}>
            <Icon name={getPlanIcon(currentPlan?.type)} size={24} className={getPlanColor(currentPlan?.type)} />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-card-foreground">Current Plan</h2>
            <p className="text-sm text-muted-foreground">Manage your subscription</p>
          </div>
        </div>
        <div className={`px-3 py-1 rounded-full text-xs font-medium ${
          currentPlan?.status === 'active' ?'bg-success/10 text-success' :'bg-warning/10 text-warning'
        }`}>
          {currentPlan?.status?.toUpperCase()}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Plan Type</p>
          <p className="font-medium text-card-foreground capitalize">{currentPlan?.name}</p>
        </div>
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Billing Cycle</p>
          <p className="font-medium text-card-foreground capitalize">{currentPlan?.billingCycle}</p>
        </div>
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Amount</p>
          <p className="font-medium text-card-foreground">${currentPlan?.price}/{currentPlan?.billingCycle === 'monthly' ? 'mo' : 'yr'}</p>
        </div>
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Next Payment</p>
          <p className="font-medium text-card-foreground">{formatDate(currentPlan?.nextPayment)}</p>
        </div>
      </div>
      <div className="bg-muted/50 rounded-lg p-4 mb-6">
        <h3 className="font-medium text-card-foreground mb-3">Plan Features</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {currentPlan?.features?.map((feature, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name="Check" size={16} className="text-success" />
              <span className="text-sm text-card-foreground">{feature}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button 
          variant="default" 
          onClick={onUpgrade}
          iconName="ArrowUp"
          iconPosition="left"
          className="flex-1"
        >
          Upgrade Plan
        </Button>
        <Button 
          variant="outline" 
          onClick={onManageBilling}
          iconName="CreditCard"
          iconPosition="left"
          className="flex-1"
        >
          Manage Billing
        </Button>
      </div>
    </div>
  );
};

export default CurrentPlanCard;